import { Outlet } from 'react-router-dom'

interface AuthLayoutProps {
  children?: React.ReactNode
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <>
      <div data-testid="auth-layout" className="auth">
        {children ?? <Outlet />}
      </div>
    </>
  )
}

export default AuthLayout
